/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sourcewhatsapp2Inputs */

const en_sourcewhatsapp2 = /** @type {(inputs: Sourcewhatsapp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const pt_sourcewhatsapp2 = /** @type {(inputs: Sourcewhatsapp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

/**
* | output |
* | --- |
* | "WhatsApp" |
*
* @param {Sourcewhatsapp2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const sourcewhatsapp2 = /** @type {((inputs?: Sourcewhatsapp2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourcewhatsapp2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sourcewhatsapp2(inputs)
	return pt_sourcewhatsapp2(inputs)
});
export { sourcewhatsapp2 as "sourceWhatsApp" }